import React, { useState } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';

import { useAuthDebug } from '@/hooks/use-auth-debug';

export const AuthDebugButton = () => {
	const { showAuthDebugAlert, checkTokenStatus } = useAuthDebug();
	const [debugVisible, setDebugVisible] = useState(false);
	const [status, setStatus] = useState<any>(null);

	const handlePress = async () => {
		setDebugVisible(!debugVisible);
		if (!debugVisible) {
			const result = await checkTokenStatus();
			setStatus(result);
		}
	};

	return (
		<View style={styles.container}>
			<Pressable
				style={styles.button}
				onPress={handlePress}
				onLongPress={showAuthDebugAlert}
			>
				<Text style={styles.buttonText}>Auth Debug</Text>
			</Pressable>

			{debugVisible && status && (
				<View style={styles.debugPanel}>
					<Text style={styles.debugText}>Session: {status.hasSession ? 'Yes' : 'No'}</Text>
					<Text style={styles.debugText}>Token Valid: {status.tokenValid ? 'Yes' : 'No'}</Text>
					{status.tokenType && (
						<Text style={styles.debugText}>Token Type: {status.tokenType}</Text>
					)}
					<Text style={styles.debugText}>
						ID Token: {status.hasIdToken ? 'Yes' : 'No'}
					</Text>
					<Text style={styles.debugText}>
						Access Token: {status.hasAccessToken ? 'Yes' : 'No'}
					</Text>
					<Text style={styles.debugText}>
						Refresh Token: {status.hasRefreshToken ? 'Yes' : 'No'}
					</Text>
					{status.refreshSuccessful !== undefined && (
						<Text style={styles.debugText}>
							Refresh Success: {status.refreshSuccessful ? 'Yes' : 'No'}
						</Text>
					)}
					{status.error && (
						<Text style={[styles.debugText, styles.errorText]}>
							Error: {String(status.error)}
						</Text>
					)}
				</View>
			)}
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		position: 'absolute',
		bottom: 20,
		right: 20,
		zIndex: 100,
	},
	button: {
		backgroundColor: '#333',
		paddingHorizontal: 12,
		paddingVertical: 8,
		borderRadius: 4,
		opacity: 0.7,
	},
	buttonText: {
		color: '#fff',
		fontSize: 12,
	},
	debugPanel: {
		backgroundColor: '#333',
		padding: 10,
		borderRadius: 4,
		marginTop: 4,
		opacity: 0.9,
		maxWidth: 300,
	},
	debugText: {
		color: '#fff',
		fontSize: 12,
		marginBottom: 4,
	},
	errorText: {
		color: '#ff5252',
	},
});
